import dayjs from 'dayjs';
import { components } from '@apiSchema';
import http from '@core/fetch';

type SnapMacListDto = components['schemas']['SnapMacListDto'];
type IdentifiedMacDto = SnapMacListDto & { id: number };

const SHORT_WORDS_COUNT = 2;

export interface IMacListItem {
    id: number;
    title: string;
    description: {
        preview: string;
        additional: string;
    };
    keywords: string[];
    countryCodeStr: string;
    itemsCount: number;
    dateStr: string;
    dateSort: Date;
    thumbnailUrl: string;
    shareLink: string;
}

export function getMacDescription(words: string[]) {
    return {
        preview: words.length > 0 ? `includes ${words.slice(0, SHORT_WORDS_COUNT).join(', ')}` : '',
        additional: words.slice(SHORT_WORDS_COUNT).join(', '),
    };
}

function hasId(dto: SnapMacListDto): dto is IdentifiedMacDto {
    return typeof dto.id === 'number';
}

function mapMacListDto(dto: IdentifiedMacDto): IMacListItem {
    const keywords = dto.includedKeywords ?? [];
    const date = dto.lastModifiedDate ?? dto.createdDate;

    return {
        id: dto.id,
        title: dto.title ?? '',
        description: getMacDescription(keywords),
        keywords,
        countryCodeStr: dto.countryCode ?? '',
        itemsCount: keywords.length,
        dateStr: date ? dayjs(date).format('MM/DD/YYYY') : '',
        dateSort: new Date(date ?? 0),
        thumbnailUrl: http.getQuery('macs thumbnail', { macId: dto.id }),
        shareLink: dto.shareLink ?? '',
    };
}

export function mapMacListDtos(dtos: SnapMacListDto[]): IMacListItem[] {
    return dtos.filter(hasId).map(mapMacListDto);
}
